"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetSubscriptionHintService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const service_VersetBilling_1 = require("./service.VersetBilling");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_VersetStickyNotification_1 = require("./service.VersetStickyNotification");
const subscriptionHint_1 = require("./subscriptionHint/subscriptionHint");
const versetUserProfileMechanism_1 = require("./versetUserProfileMechanism");
const subscriptionHintName = "subscription";
let VersetSubscriptionHintService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetSubscriptionHintService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetBillingService: service_VersetBilling_1.VersetBillingService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                VersetStickyNotificationService: service_VersetStickyNotification_1.VersetStickyNotificationService,
            });
            // Only this logged-in app instance; the next login starts with a fresh notice.
            this.deferred = false;
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetSubscriptionHintService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        async initialize() {
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.of.refresh.listenBy(this, () => void this.refresh());
            await this.refresh();
        }
        async refresh() {
            if (this.deferred) {
                return;
            }
            const [subscription, reason] = await this.deps.VersetRequireLoginService.server.rpcs.VersetUserSubscriptionService.getMySubscription({});
            // A profile refresh already in flight must not undo a Later click.
            if (this.deferred) {
                return;
            }
            if (reason || subscription.subscription.state !== "free") {
                this.deps.VersetStickyNotificationService.remove(subscriptionHintName);
                return;
            }
            const hint = new subscriptionHint_1.SubscriptionHint();
            hint.onOpenSubscription = () => {
                this.deps.VersetBillingService.showSubscriptionGate();
            };
            hint.onLater = () => {
                this.deferred = true;
                this.deps.VersetStickyNotificationService.remove(subscriptionHintName);
            };
            this.deps.VersetStickyNotificationService.showWidget({
                name: subscriptionHintName,
                widget: hint,
            });
        }
    };
    return VersetSubscriptionHintService = _classThis;
})();
exports.VersetSubscriptionHintService = VersetSubscriptionHintService;
